<template>
  <div
    class="ten-divider"
    :class="[
      `ten-divider__${direction}`,
      { 'ten-divider__dashed': dashed && direction === 'horizontal' }
    ]"
  >
    <div
      v-if="hasSlot && direction === 'horizontal'"
      class="ten-divider__title"
      :class="{
        [`ten-divider__title-${align}`]: direction === 'horizontal'
      }"
    >
      <div>
        <!-- @slot 分割线标题内容 -->
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
const name = 'ten-divider';

export default {
  name,
  props: {
    /**
     * 分割线方向
     * @member 'horizontal' / 'vertical'
     */
    direction: {
      type: String,
      default: 'horizontal',
      validator(value) {
        return ['horizontal', 'vertical'].indexOf(value) > -1;
      },
    },
    /**
     * 分割线标题位置
     * @member 'left' / 'center' / 'right'
     */
    align: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'center', 'right'].indexOf(value) > -1;
      },
    },
    /**
     * 是否是虚线风格
     */
    dashed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
  },
};
</script>
